import BotReportApi from 'api/bot-report';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import withContentLoader from 'components/ui/withContentLoader';
import BotReportCard from './BotReportCard';

const BotReportList = ({ data = [] }) => {
  if (!data.length) {
    return <NoRecords />;
  }

  const reports = data.map(report => (
    <div key={report.id} className="col-md-4 mb-4">
      <BotReportCard {...report} />
    </div>
  ));

  return <div className="row">{reports}</div>;
};

const Container = ({ botId }) => {
  const fetchData = async () => BotReportApi.fetch({ botId });
  const Component = withContentLoader(BotReportList, { name: `bot-${botId}-reports`, fetchData });
  return <Component botId={botId} />;
};

export default Container;
